<template lang="html">
  <div class="print">
    <div class="title">
      <span class="order">序号</span>
      <span class="name">报道名称</span>
      <span class="sec">记者</span>
      <span class="sec">得分</span>
      <span class="sec">摄像</span>
      <span class="sec">得分</span>
      <span class="sec">考评日期</span>
      <span class="sec">播出日期</span>
    </div>
    <div class="item" v-for="(i, d) in list" :key="d">
      <span class="order">{{d+1}}</span>
      <span class="name">{{i.report_title}}</span>
      <span class="sec">{{i.reporters}}</span>
      <span class="sec bold">{{i.reporter_res}}</span>
      <span class="sec">{{i.cameras}}</span>
      <span class="sec bold">{{i.cameras_res}}</span>
      <span class="sec">{{i.appraisal_time}}</span>
      <span class="sec">{{i.release_time}}</span>
    </div>
    <div class="btn greenBtn" @click="goPrint" v-if="list.length > 0">
      <img src="@assets/img/common/printing.svg" alt="print">
      打印
    </div>
    <div class="noData" v-else>
      暂无数据
    </div>
  </div>
</template>

<script>
import {apis} from '@common/config';
import common from '@common/common';

export default {
  name: 'print',
  data() {
    return {
      list: []
    }
  },
  created() {
    const id = this.$route.query.d
    const status = this.$route.query.s
    const start = this.$route.query.st
    const end = this.$route.query.et
    const info = {
      column_id: id,
      status: status,
      start: start,
      end: end
    }

    common.myFetch(apis.sectionEvaluationPrint, info)
    .then((r) => {
      if (r) {
        this.list = r.list
      }
    })

  },
  methods: {
    goPrint() {
      window.print()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.print {
  .noData {
    text-align: center;
    margin: 20px auto;
    color: @sub;
  }
  .title {
    display: flex;
    align-items: center;
    height: 40px;
    background-color: rgba(0,0,0,0.05);
    border: 1px solid #979797;
    font-size: 14px;
    color: @sub;
    padding: 0 30px;
  }
  .item {
    display: flex;
    align-items: center;
    min-height: 70px;
    margin: 0 30px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;
    padding: 6px 0;
  }
  .order {
    width: 50px;
    text-align: left;
    margin-right: 40px;
    white-space: nowrap;
  }
  .name {
    text-align: left;
    flex: 1;
  }
  .sec {
    width: 120px;
    text-align: center;
  }
  .bold {
    font-weight: bold;
    font-size: 18px;
    color: @sub;
  }
  .sec:last-child {
    margin-right: 100px;
  }
  .btn {
    margin: 50px auto;
    width: 120px;
    height: 40px;
    border: 1px solid @green;
    color: @green;
    font-size: 14px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      margin-right: 10px;
    }
    &:hover {
      .btnHover;
    }
    &:active {
      .btnActive;
    }
  }

  .greenBtn {
    color: #fff;
    background-color: @green;
  }

  @media print {
    .title {
      font-size: 10px;
    }
    .item {
      font-size: 12px;
    }
    .bold {
      font-weight: bold;
      font-size: 14px;
    }
    .name {
      min-width: 200px;
    }
    .sec:last-child {
      margin-right: 0;
    }
    .btn {
      display: none;
    }
  }
}
</style>
